var scope_0 = require('/builds/philbo87/deglutino/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c3b2f9e02b2829cc6630d03832f963b9.js').default;
var scope_1 = require('/builds/philbo87/deglutino/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d0cf6d56113c21ac6d3d17f1402ed7b6.js').default;
var scope_2 = require('/builds/philbo87/deglutino/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    